const Productable = {
  product: (products, subscription) => {
    // shopper#836 : lookup product by enrollment sku first to handle transfers 
    if (subscription.enrollment && subscription.enrollment.sku) {
      return products.find((product) => product.sku == subscription.enrollment.sku)
    } else if (subscription.lineItem && subscription.lineItem.product_id) {
      return products.find((product) => product.id == subscription.lineItem.product_id)
    } else {
      return products.find((product) => product.sku == subscription.sku)
    }
  },
  variant: (products, subscription) => {
    const product = Productable.product(products, subscription)
    return product && product.variants[0]
  },
  price: (products, subscription) => {
    const variant = Productable.variant(products, subscription)
    return variant && variant.price
  },
  imageSrc: (products, subscription) => {
    const product = Productable.product(products, subscription)
    return product && product.imageSrc
  },
  title: (products, subscription) => {
    const product = Productable.product(products, subscription)
    return product && product.title
  }
}

export default Productable
